import { useContext, useEffect, useState } from "react";
import "./chm-item.styles.scss";
import { CustomerOrderContext } from "../../../../contexts/customerOrder.context";
import { handleCount, handleClick, addOrderItem } from "./chm-item.utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronUp,
  faPlus,
  faMinus,
} from "@fortawesome/free-solid-svg-icons";
const CHMItem = ({ itemDetails, itemName }) => {
  const [subsectionClass, setSubsectionClass] = useState(
    "chm-subsection-visible"
  );
  const [count, setCount] = useState(0);
  const { customerOrderContext, setCustomerOrderContext } =
    useContext(CustomerOrderContext);
  useEffect(() => {
    if (customerOrderContext[itemName]) {
      const tempObject = customerOrderContext[itemName];
      const tempCount = tempObject["itemCount"];
      setCount(tempCount);
    }
  }, [customerOrderContext]);
  useEffect(() => {
    if (itemDetails["metadata"] === "item") {
      if (count !== 0) {
        var tempItemTotal = count * itemDetails["price"];
        var tempOrderItem = {
          itemCount: count,
          itemTotal: tempItemTotal,
        };
        setCustomerOrderContext({
          ...customerOrderContext,
          [itemName]: tempOrderItem,
        });
      } else {
        var newObject = {};
        Object.keys(customerOrderContext).map((index) => {
          if (index !== itemName) {
            newObject = { ...newObject, [index]: customerOrderContext[index] };
          }
        });
        setCustomerOrderContext(newObject);
      }
    }
  }, [count]);
  if (itemDetails["metadata"] === "category") {
    return (
      <div className="chm-category-container">
        <div className="chm-category-details">
          <span className="chm-category-name">{itemName}</span>
          <span
            className="chm-category-hide"
            onClick={() => handleClick(subsectionClass, setSubsectionClass)}
          >
            {subsectionClass === "chm-subsection-hidden" ? (
              <FontAwesomeIcon icon={faChevronDown} />
            ) : (
              <FontAwesomeIcon icon={faChevronUp} />
            )}
          </span>
        </div>
        <div className={subsectionClass}>
          {Object.keys(itemDetails).map((index) => {
            if (index !== "metadata") {
              return (
                <CHMItem
                  key={index}
                  itemDetails={itemDetails[index]}
                  itemName={index}
                />
              );
            }
          })}
        </div>
      </div>
    );
  } else if (itemDetails["metadata"] === "item") {
    return (
      <div className="chm-item-container">
        <div className="chm-item-details">
          <span className="chm-item-name">{itemName}</span>
          <span className="chm-item-price">{itemDetails["price"]}</span>
          <span className="chm-item-description">
            {itemDetails["description"]}
          </span>
        </div>
        <div className="chm-item-add-buttons">
          <span
            className="chm-item-add-button"
            onClick={() => handleCount("negative", setCount, count)}
          >
            <FontAwesomeIcon icon={faMinus} />
          </span>
          <span className="chm-item-count">{count}</span>
          <span
            className="chm-item-add-button"
            onClick={() => handleCount("positive", setCount, count)}
          >
            <FontAwesomeIcon icon={faPlus} />
          </span>
        </div>
      </div>
    );
  }
};
export default CHMItem;
